import React from "react";
import {ReactComponent as Frame41223 } from "../components/assests/overlayService/frame-41223.svg";
import {ReactComponent as Frame48095970 } from "../components/assests/overlayService/frame-48095970.svg";
import {ReactComponent as Line39 } from "../components/assests/overlayService/line-39.svg";
import {ReactComponent as Triangle } from "../components/assests/overlayService/triangle.svg";
import {ReactComponent as Vector } from "../components/assests/overlayService/vector.svg";
import "./style.css";

export const OverlayServices = () => {
  return (
    <div className="overlay-services">
      <div className="div">
        <Frame48095970 className="frame" />
        <Frame48095970 className="frame-48095970" />
        <Frame48095970 className="frame-48095971" />
        <Frame48095970 className="frame-48095969" />
        <Frame48095970 className="frame-48095856" />
        <Frame48095970 className="frame-48095970-instance" />
        <Frame48095970 className="frame-48095971-instance" />
        <div className="overlap">
          <img className="line" alt="Line" />
          <div className="frame-2">
            <div className="frame-wrapper">
              <div className="div-wrapper">
                <div className="frame-3">
                  <div className="planification-strat-wrapper">
                    <p className="planification-strat">
                      <span className="text-wrapper">
                        Planification
                        <br />
                      </span>
                      <span className="span">stratégique</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="frame-4">
              <div className="frame-5">
                <div className="frame-6">
                  <Line39 className="line-39" />
                  <div className="frame-7">
                    <div className="frame-8">
                      <div className="group">
                        <div className="frame-9">
                          <Vector className="vector-instance" />
                          <div className="heading-example">DESCRIPTION</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="group-wrapper">
                  <div className="heading-example-wrapper">
                    <p className="p">
                      La planification stratégique financière est un service essentiel offert par notre cabinet de
                      finance, visant à aider nos clients à atteindre leurs objectifs financiers à long terme de manière
                      efficace et durable.
                    </p>
                  </div>
                </div>
              </div>
              <p className="heading-example-2">
                En combinant une analyse approfondie des finances personnelles ou d&#39;entreprise avec une vision
                stratégique, nous élaborons des stratégies sur mesure pour optimiser la gestion des ressources
                financières et maximiser les rendements.
              </p>
            </div>
            <div className="component">
              <div className="play">
                <div className="overlap-group">
                  <Triangle className="triangle-instance" />
                </div>
              </div>
            </div>
            <div className="frame-10">
              <div className="frame-11">
                <div className="frame-6">
                  <Line39 className="line-39" />
                  <div className="frame-7">
                    <div className="frame-8">
                      <div className="group-2">
                        <div className="frame-9">
                          <Vector className="vector-instance" />
                          <div className="heading-example">AVANTAGES</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="frame-12">
                  <div className="frame-8">
                    <div className="group-3">
                      <div className="heading-example-3">Maximisation des rendements</div>
                    </div>
                    <p className="heading-example-4">
                      Identification des opportunités d&#39;investissement et de croissance pour optimiser les
                      rendements financiers
                    </p>
                  </div>
                </div>
                <div className="frame-12">
                  <div className="frame-8">
                    <div className="group-3">
                      <div className="heading-example-3">Gestion des risques</div>
                    </div>
                    <p className="heading-example-4">
                      Élaboration de stratégies de gestion des risques pour protéger les actifs et minimiser les pertes
                      potentielles
                    </p>
                  </div>
                </div>
              </div>
              <img className="img" alt="Line" />
            </div>
            <div className="frame-13">
              <div className="frame-11">
                <div className="frame-6">
                  <Line39 className="line-39" />
                  <div className="frame-7">
                    <div className="frame-8">
                      <div className="group-4">
                        <div className="frame-9">
                          <Vector className="vector-instance" />
                          <div className="heading-example">PROCESSUS</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="frame-12">
                  <div className="frame-8">
                    <div className="group-3">
                      <div className="heading-example-3">Analyse financière approfondie</div>
                    </div>
                    <p className="heading-example-4">
                      Évaluation des états financiers, des flux de trésorerie et des besoins en capitaux pour comprendre
                      la situation actuelle
                    </p>
                  </div>
                </div>
                <div className="frame-12">
                  <div className="frame-8">
                    <div className="group-3">
                      <div className="heading-example-3">Élaboration de stratégies personnalisées</div>
                    </div>
                    <p className="heading-example-4">
                      Développement de plans financiers sur mesure en fonction des objectifs spécifiques du client et de
                      son appétence au risque
                    </p>
                  </div>
                </div>
              </div>
              <img className="line-2" alt="Line" />
            </div>
          </div>
          <Frame41223 className="frame-41223" />
        </div>
      </div>
    </div>
  );
};
export default OverlayServices;